import { brand } from "../../../config/appData";
import "./WelcomeEnquiryModal.css";

function WelcomeEnquiryModal({ isOpen, onClose, onSendEnquiry }) {


  if (!isOpen) return null;

  const handleEnquiryClick = () => {
    onClose();
    onSendEnquiry();
  };

  return (
    <div
      className="welcome-enquiry-overlay"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="welcome-enquiry-box">
        <button
          type="button"
          className="welcome-enquiry-close"
          onClick={onClose}
          aria-label="Close"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        <p className="welcome-enquiry-brand">{brand.name}</p>
        <p className="welcome-enquiry-text">
          Have a question or want to know more? Tell us what you need.
        </p>
        <p className="welcome-enquiry-text">Send us your enquiry 💍</p>

        <button
          type="button"
          className="welcome-enquiry-btn"
          onClick={handleEnquiryClick}
        >
          Enquiry Now
        </button>
      </div>
    </div>
  );
}

export default WelcomeEnquiryModal;
